import React from "react"
import "../../styles/Layouts/toggleLogin.css"

const ToggleLogin = ({ toggleLanguage, currentLanguage }) => {
  const isArabic = currentLanguage === "ar"

  const handleToggle = () => {
    toggleLanguage(isArabic ? "en" : "ar")
  }

  return (
    <div className="login-language-toggle">
      <div className="login-toggle-switch" onClick={handleToggle}>
        <div className={`login-lang-option ${!isArabic ? "active" : ""}`}>
          En
        </div>
        <div className={`login-lang-option ${isArabic ? "active" : ""}`}>ع</div>
      </div>
    </div>
  )
}

export default ToggleLogin
